module.exports = __webpack_public_path__ + "img/t_1.3eeb80e6.jpg";